import { createSlice } from "@reduxjs/toolkit";
import { createApi } from "../../utils/api";
import { deleteParameterConfiguration } from "../../common/endpoints";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const deleteParamConfig = createApi(
  deleteParameterConfiguration,
  "DELETE"
);

const deleteParameterConfigSlice = createSlice({
  name: "deleteParameterConfig",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteParamConfig.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteParamConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(deleteParamConfig.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default deleteParameterConfigSlice.reducer;
